import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { BookingApi } from '@/api';
import { DataGrid } from '@/components';
import { useDataGridColumns } from '@/components/DataGrid/hooks/useDataGridCols';
import {
  DataGridColSettings,
  mergeColumnSettings,
} from '@/components/DataGrid/utils';
import { LocalStoragePrefix } from '@/constants';
import { bookingHistoryDataGridCols } from '@/pages/JMS/Managament/components/grids/columns/bookingHistoryDataCols';
import { JmsManagementRoutes } from '@/pages/JMS/Managament/utils/utils';
import { useUserStore } from '@/store';
import { getLocalStorageItem } from '@/utils';

export const BookingHistoryDataGrid = () => {
  const navigate = useNavigate();
  const { user } = useUserStore();
  const { inmateId } = useParams();

  const fetchInmates = async (page = 1, limit = 10, filter = '', sort = '') => {
    try {
      const response = await BookingApi.listByInmate(inmateId as string, {
        page,
        limit,
        filter,
        sort,
      });

      return {
        rows: response.data.docs,
        totalCount: response.data.totalDocs,
      };
    } catch (error) {
      return {
        rows: [],
        totalCount: 0,
      };
    }
  };

  const [columnSettings, setColumnSettings] = useState<DataGridColSettings[]>(
    () => {
      const savedSettings = getLocalStorageItem({
        key: String(user?._id),
        prefix: `inmate-bookings-history-${LocalStoragePrefix.TableSetting}`,
        shouldParse: true,
      });

      if (!savedSettings) {
        return bookingHistoryDataGridCols;
      }

      return mergeColumnSettings(bookingHistoryDataGridCols, savedSettings);
    },
  );

  const handleView = (bookingId: string) => {
    navigate(JmsManagementRoutes.ViewBooking(bookingId));
  };

  const columns = useDataGridColumns({
    type: 'inmateBookingHistory',
    columnSettings,
    onView: handleView,
  });

  return (
    <DataGrid
      name="inmate-bookings-history"
      columns={columns}
      columnSettings={columnSettings}
      setColumnSettings={setColumnSettings}
      fetchData={fetchInmates}
    />
  );
};
